export const SYSTEMS = [
  {
    index: "01",
    name: "Energy",
    title: "170mg clean energy stack",
    ingredients: "Enfinity® Paraxanthine · Sunphenon® Green Tea · Cordyceps Militaris · Suntheanine® L-Theanine",
    outcome: "Calm, smooth, jitter-free energy and endurance — minus the crash.",
  },
  {
    index: "02",
    name: "Mood",
    title: "Mood & motivation",
    ingredients: "Affron® Saffron · Phosphatidylserine · Ashwagandha",
    outcome: "Brain health, stress resilience and emotional balance.",
  },
  {
    index: "03",
    name: "Cognition",
    title: "Cognitive clarity",
    ingredients: "Lion’s Mane · Bacopa Monnieri · Cognizin® Citicoline · Rhodiolife® · Holy Basil",
    outcome: "Mental stamina, fatigue resistance, dialed focus and sharper memory.",
  },
  {
    index: "04",
    name: "Recovery",
    title: "Stress resilience & recovery",
    ingredients: "Magnesium Bisglycinate · UC3 Clear® Curcumin · Quali®-C Vitamin C",
    outcome: "Inflammation, muscle recovery, immunity and sleep support.",
  },
];

export const FOUNDERS = [
  {
    name: "Andrew Hill",
    role: "Co-founder · Brand & Product",
    image: "/assets/invest/andrew-hill.jpg",
    bio: "Built LiftEd, a VC-backed EdTech company, through its 2022 acquisition by the largest global provider of autism technology services. After rebuilding his health and performance from the ground up, Andrew shaped the product he wished he had through that journey.",
  },
  {
    name: "Dave Salvant",
    role: "Co-founder · GTM & Capital",
    image: "/assets/invest/dave-salvant.jpg",
    bio: "Co-founded SQUIRE, the software platform serving more than 6,000 barbershops and processing over a billion dollars annually. An Endeavor Entrepreneur and EY Entrepreneur Of The Year, Dave brings category-building, capital and operating scale.",
  },
  {
    name: "Verick Wayne",
    role: "Co-founder · Brand & Growth",
    image: "/assets/invest/verick-wayne.jpg",
    bio: "A decade helping founders turn businesses into growth engines. Companies he has advised have generated more than $100 million in revenue across positioning, acquisition, sales and go-to-market systems.",
  },
];

export const COMPARISON_ROWS = [
  { label: "Paraxanthine, not straight caffeine", values: [true, false, false, false] },
  { label: "Calm, sustained focus", values: [true, true, false, true] },
  { label: "Mood & motivation, not just focus", values: [true, false, false, false] },
  { label: "Blunts cortisol; builds stress resilience", values: [true, false, false, false] },
  { label: "Recovery, not just push-through", values: [true, false, false, false] },
  { label: "Built for training and thinking", values: [true, false, false, false] },
  { label: "0g sugar; no sucralose", values: [true, false, false, true] },
];

export const USE_OF_FUNDS = [
  ["01", "Production", "Scale the first commercial runs and deepen inventory readiness."],
  ["02", "Demand", "Convert high-intent early users into a repeatable DTC acquisition engine."],
  ["03", "Distribution", "Build the systems and relationships required for selective retail expansion."],
  ["04", "Team", "Add focused operating capacity around growth, supply and customer experience."],
];